import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum ClaimAction {
  SUBMIT_CLAIM = "SUBMIT_CLAIM",
  CLEAN_UP = "CLEAN_UP",
  UPLOAD_INVOICE_REQUEST = "UPLOAD_INVOICE_REQUEST",
  UPLOAD_INVOICE_SUCCESS = "UPLOAD_INVOICE_SUCCESS",
  UPLOAD_INVOICE_FAILURE = "UPLOAD_INVOICE_FAILURE",
  RESTORE_CLAIM_DATA = "RESTORE_CLAIM_DATA",
}

export type ClaimState = Readonly<{
  uploadedInvoiceUrl?: string | null;
  claimData?: any;
}>;

export type ClaimActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export const ClaimScope = "claim";
